export default {
  KnownTravelerNumberFormField__ARIA: "Known traveler number",
  KnownTravelerNumberFormField__INFO_TIP_ARIA: (label) => `More information about ${label}`,
  KnownTravelerNumberFormField__LABEL: "Known traveler number (KTN)",
  KnownTravelerNumberFormField__OPTIONAL: "Optional",
};
